
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6c39bc4b&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ChoiceApp.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ChoiceApp.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6c39bc4b!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ChoiceApp.vue"),
  /* scopeId */
  "data-v-6c39bc4b",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/views/activity/ChoiceApp.vue
// module id = 381
// module chunks = 2